export enum CandidateCardEnum {
  holdDownSiblingsSelector = '.candidate-card',
  holdDownSiblingsClass = 'candidate-card',
  defaultCardBlockType = 'skills-and-experience'
}
